module.exports = "/assets/js/458031f87620af1c42550ef2655fa4e8.svg";